export default {
  "content": "<g clip-path=\"url(#clip0_9595_4906)\"><g clip-path=\"url(#clip1_9595_4906)\"><path d=\"M45 4H3a3 3 0 100 6h1v33a3 3 0 006 0V26h28v17a3 3 0 006 0V10h1a3 3 0 000-6zM28.8 20h-9.6a3.101 3.101 0 01-3.2-3 3.1 3.1 0 013.2-3h9.6a3.101 3.101 0 013.2 3 3.1 3.1 0 01-3.2 3z\" fill=\"#3F4450\"/></g></g><defs><clipPath id=\"clip0_9595_4906\"><path fill=\"#fff\" d=\"M0 0h48v48H0z\"/></clipPath><clipPath id=\"clip1_9595_4906\"><path fill=\"#fff\" d=\"M0 0h48v48H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};